import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import PatientWorkplaceMemberRelations from './PatientWorkplaceMemberRelations';

loadDOMComponent({
	selector: 'react-patient-workplace-member-relations',
	callback: ({ container }) => {
		const linkContinue = container.getAttribute('linkContinue') || null;
		const gqlParams = JSON.parse(container.getAttribute('gqlParams') || '{}');

		// selectLink
		ReactDOM.render(
			<AppContextProvider>
				<PatientWorkplaceMemberRelations
					linkContinue={linkContinue}
					gqlParams={gqlParams}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
